import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import { getMarketing } from '../content/marketing';
import '../styles/site.css';
import './SiteFooter.css';

const SiteFooter = () => {
  const { i18n } = useTranslation();
  const content = getMarketing(i18n.language);
  const tr = i18n.language?.startsWith('tr');

  return (
    <footer className="site-footer">
      <div className="arc-container site-footer-top">
        <div className="site-footer-brand">
          <Link to="/" className="site-footer-logo">
            <Logo size="medium" variant="full" className="arc-logo-light" />
          </Link>
          <p className="site-footer-blurb">{content.footer.blurb}</p>
          <div className="site-footer-cta">
            <Link to="/signup" className="arc-btn arc-btn-solid">
              {tr ? 'Başla' : 'Start'}
            </Link>
            <Link to="/contact" className="arc-btn arc-btn-ghost">
              {tr ? 'İletişim' : 'Contact'}
            </Link>
          </div>
        </div>

        <div className="site-footer-cols">
          {content.footer.columns.map((col) => (
            <div className="site-footer-col" key={col.title}>
              <h4>{col.title}</h4>
              <ul>
                {col.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="arc-container site-footer-bottom">
        <p>{content.footer.rights}</p>
        <div className="site-footer-meta">
          <Link to="/docs">Docs</Link>
          <Link to="/status">Status</Link>
          <Link to="/help">Help</Link>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
